import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from 'react';
const CUSTOM_THEME_COLORS_TO_RADIX_COLORS = {
    accent: 'indigo',
    neutral: 'gray',
    error: 'tomato',
    success: 'grass',
    warning: 'amber',
    info: 'sky',
};
export function withMappingProps(WrappedComponent, defaultProps) {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const WithMappingPropsComponent = forwardRef((props, forwardedRef) => {
        const mappedProps = {
            ...defaultProps,
            ...props,
        };
        if ('color' in mappedProps && mappedProps.color) {
            const color = mappedProps.color;
            if (color in CUSTOM_THEME_COLORS_TO_RADIX_COLORS) {
                mappedProps.color = CUSTOM_THEME_COLORS_TO_RADIX_COLORS[color];
            }
        }
        if ('weight' in mappedProps && mappedProps.weight) {
            const weight = mappedProps.weight;
            if (typeof weight === 'object' && weight !== null) {
                const responsiveWeight = {};
                for (const [key, value] of Object.entries(weight)) {
                    if (value === 'semibold') {
                        responsiveWeight[key] = 'medium';
                        mappedProps[`data-weight-${key}`] = 'semibold';
                    }
                    else if (value) {
                        responsiveWeight[key] = value;
                    }
                }
                mappedProps.weight = responsiveWeight;
            }
            else if (weight === 'semibold') {
                mappedProps.weight = 'medium';
                mappedProps['data-weight'] = 'semibold';
            }
        }
        return _jsx(WrappedComponent, { ...mappedProps, ref: forwardedRef });
    });
    WithMappingPropsComponent.displayName = displayName;
    return WithMappingPropsComponent;
}
//# sourceMappingURL=radix.js.map